import { Table } from 'antd'
import React, { FunctionComponent, useMemo } from 'react'

import { SubjectAreaSummaryItem } from '../../../common/subjectTypes'
import { Money } from '../Money/Money'

export interface SubjectDetailAreaSummaryTableSummaryProps {
  dataSource: SubjectAreaSummaryItem[] | null
}

const initial = {
  areaM: 0,
  areaHa: 0,
  lpisArea: 0,
  priceBpej: 0,
}

export const SubjectDetailAreaSummaryTableSummary: FunctionComponent<SubjectDetailAreaSummaryTableSummaryProps> =
  ({ dataSource }) => {
    const total = useMemo(() => {
      if (!dataSource) return initial
      return dataSource.reduce(
        (acc, item) => ({
          areaM: acc.areaM + item.areaM,
          areaHa: acc.areaHa + item.areaHa,
          lpisArea: acc.lpisArea + item.lpisArea,
          priceBpej: acc.priceBpej + item.priceBpej,
        }),
        initial
      )
    }, [dataSource])

    return (
      <Table.Summary.Row className="font-semibold text-right bg-[#f5f5f5]">
        <Table.Summary.Cell index={0} className="text-left">
          Celkem
        </Table.Summary.Cell>
        <Table.Summary.Cell index={1}>
          <Money
            amount={total.priceBpej}
            decimalNumbers={0}
            symbol="Kč"
            grayscale
            className={total.priceBpej === 0 ? 'text-gray-400' : ''}
          />
        </Table.Summary.Cell>
        <Table.Summary.Cell index={2}>
          <Money
            amount={total.areaM}
            decimalNumbers={0}
            symbol="m²"
            grayscale
            className={total.areaM === 0 ? 'text-gray-400' : ''}
          />
        </Table.Summary.Cell>
        <Table.Summary.Cell index={3}>
          <Money
            amount={total.areaHa}
            decimalNumbers={2}
            symbol="ha"
            grayscale
            className={total.areaHa === 0 ? 'text-gray-400' : ''}
          />
        </Table.Summary.Cell>
        <Table.Summary.Cell index={4}>
          <Money
            amount={total.lpisArea}
            decimalNumbers={0}
            symbol="m²"
            grayscale
            className={total.lpisArea === 0 ? 'text-gray-400' : ''}
          />
        </Table.Summary.Cell>
        <Table.Summary.Cell index={5}>
          <Money
            amount={(total.lpisArea / total.areaM) * 100}
            decimalNumbers={2}
            symbol="%"
            grayscale
            className={!total.lpisArea ? 'text-gray-400' : ''}
          />
        </Table.Summary.Cell>
      </Table.Summary.Row>
    )
  }
